import api from '@/apis'

export default {
  state: {
    loading: false,
    search: null,
    intent_id: null,
    search_result: []
  },
  mutations: {
    SET_ALIAS_CARD_LOADING(state, payload) {
      state.loading = payload
    },
    SET_ALIAS_CARD_SEARCH(state, payload) {
      state.search = payload
    },
    SET_ALIAS_CARD_INTENT_ID(state, payload) {
      state.intent_id = payload
    },
    SET_ALIAS_CARD_SEARCH_RESULT(state, payload) {
      state.search_result = payload
    }
  },
  actions: {
    async searchAliasList({ state, commit }) {
      try {
        commit('SET_ALIAS_CARD_LOADING', true)
        commit('SET_ALIAS_CARD_SEARCH_RESULT', [])
        const response = await api.getAliasList({ search: state.search, intent_id: state.intent_id })
        if (response.data.success) commit('SET_ALIAS_CARD_SEARCH_RESULT', response.data.data)
        else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_ALIAS_CARD_LOADING', false)
      }
    },
    async createAlias({ commit, dispatch }, payload) {
      try {
        commit('SET_ALIAS_CARD_LOADING', true)
        commit('SET_ALIAS_CARD_SEARCH_RESULT', [])

        const response = await api.createAlias({ params: payload })
        if (response.data.success) {
          if (window.location.pathname.split('/')[2] === 'alias') dispatch('fetchEntityList')
          dispatch('searchAliasList')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_ALIAS_CARD_LOADING', false)
      }
    }
  }
}
